var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24}},[_c('chart',{ref:"detailChart",staticClass:"echarts",staticStyle:{"height":"300px"},attrs:{"options":_vm.detailOption,"id":"detailChart"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }